import { http } from "@/providers/http";
export class NotAcceptedEmailApi {
  private static INSTANCE = new NotAcceptedEmailApi();

  static get instance() {
    return this.INSTANCE;
  }

  public sendEmailData(formData: any) {
    const endpoint = "cprs/email";
    const headers = {
      ...http.getTokenHeaders(),
      "Content-Type": "multipart/form-data",
    };
    return http.post(endpoint, headers, formData, true).then((response) => {
      return response;
    });
  }

  /**
   * `query` is a complete `key=value` pair, not a bare id: the history can be
   * scoped by applicationId, userId or email, and only the caller knows which
   * one this email is keyed on. Hardcoding `applicationId=` here wrote the key
   * twice for the application case and sent the wrong key entirely for the
   * other two.
   */
  public getEmailHistory(query: string) {
    const endpoint = `cprs/email?${query}`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers).then((response) => {
      return response;
    });
  }

  /**
   * Unread summary for the signed-in reviewer, used by the notification bell.
   *
   * Returns one row per thread - not per mail - each carrying its own
   * unreadCount and the latest sender, subject and date, alongside a
   * totalUnreadCount for the whole feed. Resolves to an empty list on failure
   * so the bell renders its empty state instead of surfacing an error.
   */
  public getUnreadMails() {
    const endpoint = `cprs/email/unread`;
    const headers = http.getTokenHeaders();
    return http
      .get(endpoint, headers)
      .then((response: any) => {
        const payload = response?.data ?? response;
        return payload?.data ?? [];
      })
      .catch(() => {
        return [];
      });
  }

  /**
   * Mark a thread read. `query` is a complete `key=value` pair for the same
   * three scopes the history accepts (applicationId, userId or email), so the
   * caller states which key this mail is actually keyed on.
   *
   * Called only when the reviewer opens a notification or clears the list --
   * never on the polling fetch, which would mark mail read without it being
   * seen. Swallows failure so the panel's own state stays authoritative.
   */
  public markEmailRead(query: string) {
    const endpoint = `cprs/email/read?${query}`;
    const headers = http.getTokenHeaders();
    return http
      .put(endpoint, headers)
      .then((response: any) => {
        return response;
      })
      .catch(() => {
        return null;
      });
  }
}

export const notAcceptedEmailApi = NotAcceptedEmailApi.instance;
